import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';
import { ManageNotificationsComponent } from './manage-notifications.component';



@NgModule({
  declarations: [
    ManageNotificationsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class ManageNotificationsModule { }
